<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-select
        placeholder="所属流程"
        allowClear
        show-search
        :filter-option="filterOption"
        class="a_input_self margin_self"
        v-model="queryParam.processDefKey"
        @keyup.enter.native="$refs.table.refresh(true)"
      >
        <a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
          {{ item.name }}
        </a-select-option>
      </a-select>
      <a-input
        placeholder="流程标题"
        allowClear
        class="a_input_self margin_self"
        v-model="queryParam.processName"
        @keyup.enter.native="$refs.table.refresh(true)"
      />
       <!-- <a-input
        placeholder="请输入审批编号"
        allowClear
        class="a_input_self margin_self"
        v-model="queryParam.applyCode"
        @keyup.enter.native="$refs.table.refresh(true)"
      /> -->
      <a-select
        allowClear
        placeholder="请选择所属公司"
        class="a_input_self margin_self"
        v-model="queryParam.companyId"
        @change="handlecompanyplan"
        style="width: 200px"
      >
        <a-select-option :value="item.value" v-for="(item, index) in companyList" :key="index">
          {{ item.title }}
        </a-select-option>
      </a-select>
      <a-tree-select
        allowClear
        :treeData="departList"
        placeholder="请选择部门"
        v-model="queryParam.deptId"
        class="a_input_self margin_self"
        style="width: 200px"
      >
      </a-tree-select>
      <!-- <a-select allowClear placeholder="所属部门" class="a_input_self margin_self" v-model="queryParam.departId" @change="changeDepart" style="width: 200px">
          <a-select-option :value="item.value" v-for="(item, index) in departList" :key="index" >
            {{ item.title }}
          </a-select-option>
			</a-select> -->
      <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
      <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>

      <!-- <a-button v-if="batchAgreeTasking" :disabled="selectedRowKeys.length===0" type="primary" icon="check" @click="handelAuditBatch(selectedRowKeys,2)">批量同意</a-button>
      <a-button v-if="batchRejectTasking" :disabled="selectedRowKeys.length===0" icon="close" @click="handelAuditBatch(selectedRowKeys,3)">批量驳回</a-button> -->
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <s-table size="default" ref="table" rowKey="id" :scroll="{ y: scroll_y }" :columns="columns" :data="loadData"  defaultSort="endTime">
        <span slot="serial" slot-scope="text, record, index">
          {{ index + 1 }}
        </span>
        <!-- <span slot="suspended" slot-scope="text">
          <a-badge :status="text ? 'error' : 'processing'" :text="text ? '挂起' : '激活'" />
        </span> -->
        <span slot="action" slot-scope="text, record">
          <!-- <a-divider v-if="editEnabel" type="vertical" />
        <a v-if="editEnabel" @click="handleEdit(record.id)">编辑</a> -->
          <a v-if="sanctionTasking" @click="handelAudit(record)" :disabled="record.suspended">审批</a>
          <a-divider type="vertical" />
          <a v-if="historyTasking" @click="handFlow(record)">历史</a>
        </span>
      </s-table>
    </div>

    <leave-modal ref="leavemodal" @ok="handleOk" />
    <!-- 采购申请 -->
    <purchase-modal ref="purchasemodal" @ok="handleOk" />
    <proc-flow-modal ref="modal" @ok="handleOk" />
    <!-- 报废 -->
    <scrap-modal ref="scrapmodal" @ok="handleOk" />
    <!-- 审批领用 -->
    <receive-modal ref="receiveModal" @ok="handleOk" />
    <operation-modal ref="operationmodal" @ok="handleOk" />
    <service-modal ref="servicemodal" @ok="handleOk" />
    <reimbursement-modal ref="reimbursementmodal" @ok="handleOk" />
    <!-- 付款详情 -->
    <payMentModal ref="paymentmodal" @ok="handleOk" />
    <!-- 详情 -->
    <contractModal ref="contractmodal" @ok="handleOk" />
    <sealModal ref="sealmodal" @ok="handleOk" />
    <currencyModal ref="currencymodal" @ok="handleOk" />
    <returnModal ref="returnmodal" @ok="handleOk" />
    <car-modal ref="carmodal" @ok="handleOk" />
    <returncar-modal ref="returncarmodal" @ok="handleOk" />
    <salaryModal ref="salarymodal" @ok="handleOk" />
    <adjustmentModal ref="adjustmentmodal" @ok="handleOk" />
    <charge-modal ref="chargemodal" @ok="handleOk" />
    <other-modal ref="othermodal" @ok="handleOk" />
    <feedback-modal ref="feedbackmodal" @ok="handleOk" />
    <inventory-modal ref="inventorymodal" @ok="handleOk" />
    <salaryEditModal ref="salaryEditModal" @ok="handleOk"></salaryEditModal>
    <quotation ref="quotation"  @ok="handleOk"></quotation>
    <contractReview ref="contractReview" @ok="handleOk"></contractReview>
    <tender ref="tender" @ok="handleOk"></tender>
		<contractDetail ref="contractDetail"  @ok="handleOk"></contractDetail>
    <terminationModal ref="terminationModal"  @ok="handleOk"></terminationModal>
    

  </div>
</template>

<script>
import terminationModal from '@/views/activiti/modules/terminationModal.vue'
import contractDetail from '@/views/projectCollection/contract/contractDetail.vue'
import salaryEditModal from './modules/salaryEditModal.vue'
import { tree_all } from '@/api/purchase'
import { STable } from '@/components'
import { getTasking, auditTaskBatch, modalMap } from '@/api/activiti'
import { audit_list } from '@/api/financial'
import LeaveModal from './modules/LeaveModal.vue'
import PurchaseModal from './modules/PurchaseModal.vue'
import ProcFlowModal from './modules/ProcFlowModal.vue'
import { checkPermission } from '@/utils/permissions'
import ScrapModal from './modules/ScrapModal.vue'
import receiveModal from './modules/receiveModal.vue'
import OperationModal from './modules/OperationModal.vue'
import ServiceModal from './modules/ServiceModal.vue'
import ReimbursementModal from './modules/ReimbursementModal.vue'
import payMentModal from '@/views/activiti/modules/payMentModal.vue'
import contractModal from '@/views/activiti/modules/contractModal.vue'
import sealModal from '@/views/activiti/modules/sealModal.vue'
import currencyModal from '@/views/activiti/modules/currencyModal.vue'
import returnModal from '@/views/activiti/modules/returnModal.vue'
import carModal from '@/views/activiti/modules/carModal.vue'
import returncarModal from '@/views/activiti/modules/returncarModal.vue'
import salaryModal from '@/views/activiti/modules/salaryModal.vue'
import adjustmentModal from '@/views/activiti/modules/adjustmentModal.vue'
import chargeModal from '@/views/activiti/modules/chargeModal.vue'
import otherModal from '@/views/activiti/modules/otherModal.vue'
import feedbackModal from '@/views/activiti/modules/feedbackModal.vue'
import InventoryModal from '@/views/activiti/modules/InventoryModal.vue'
import quotation from './modules/quotation.vue'
import contractReview from '@/views/activiti/modules/contractReview.vue'
import tender from '@/views/activiti/modules/tender.vue'
export default {
  name: 'Tasking',
  components: {
    contractDetail,
    tender,
    contractReview,
    quotation,
    salaryEditModal,
    STable,
    LeaveModal,
    ProcFlowModal,
    PurchaseModal,
    ScrapModal,
    receiveModal,
    OperationModal,
    ServiceModal,
    ReimbursementModal,
    payMentModal,
    contractModal,
    sealModal,
    currencyModal,
    returnModal,
    carModal,
    returncarModal,
    salaryModal,
    adjustmentModal,
    chargeModal,
    otherModal,
    feedbackModal,
    InventoryModal,
    terminationModal,
  },
  data() {
    return {
      // searchType: '',
      sortedInfo: null,
      departList: [],
      companyList: [],
      Approvallist: [],
      value: '',
      treeData: [],
      scroll_y: 150,
      visible: false,
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      form: this.$form.createForm(this),
      mdl: {},
      permissions: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        departId: undefined,
        processDefKey: undefined,
        applyCode: '',
      },
      // 表头
      columns: [
        {
          title: '序号',
          scopedSlots: {
            customRender: 'serial',
          },
           width: 60,
        },
        {
          title: '审批编号',
          dataIndex: 'applyCode',
          width: 260,
          ellipsis: true,
        },
        {
          title: '所属公司',
          dataIndex: 'companyName',
          ellipsis: true,
        },
        {
          title: '所属部门',
          dataIndex: 'deptName',
          ellipsis: true,
        },
        {
          title: '流程标题',
          dataIndex: 'processName',
          ellipsis: true,
        },
        {
          title: '所属流程',
          dataIndex: 'processDefName',
          ellipsis: true,
        },
        {
          title: '金额(元)',
          dataIndex: 'money',
          ellipsis: true,
        },
        {
          title: '当前审批环节',
          dataIndex: 'name',
          ellipsis: true,
        },
        {
          title: '申请人',
          dataIndex: 'applyer',
          ellipsis: true,
        },
         {
          title: '申请时间',
          dataIndex: 'applyerTime',
          sorter: true,
          ellipsis: true,
        },
        {
          title: '下发时间',
          dataIndex: 'createTime',
          sorter: true,
          ellipsis: true,
        },
        // {
        //   title: '状态',
        //   dataIndex: 'suspended',
        //   scopedSlots: {
        //     customRender: 'suspended',
        //   },
        // },
        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action',
          },
        },
      ],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getTasking(Object.assign(parameter, this.queryParam))
      },
      previewVisible: false,
      previewImage: '',
      selectedRowKeys: [],
      selectedRows: [],
      sanctionTasking: checkPermission('settings:tasking:sanction'),
      historyTasking: checkPermission('settings:tasking:history'),
      batchAgreeTasking: checkPermission('settings:tasking:batchAgree'),
      batchRejectTasking: checkPermission('settings:tasking:batchReject'),
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.suspended, // Column configuration not to be checked
          },
        }),
      }
    },
  },
  filters: {},
  created() {
    audit_list().then((res) => {
      this.Approvallist = res.data
    })

    tree_all().then((res) => {
      if (res.code == 200) {
        this.companyList = res.data[0]
      }
    })
  },

  //   mounted() {
  //     this.$nextTick(() => {
  //       var max_h = $('#content_main_center_scroll').height()
  //       setTimeout(() => {
  //         this.scroll_y = max_h - $('.ant-table-header').height() - 100
  //       }, 1000)
  //     })
  //   },

  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() -40
      }, 1000)
    })
  },
  methods: {
    // 选择公司
    handlecompanyplan(e) {
      this.queryParam.departId = undefined
      console.log(e, 'eeeeeeeeeeeeeeeeeeeeeee')
      this.companyList.forEach((item) => {
        if (item.value == e) {
          // this.formList.companyName = item.title
          this.departList = item.children
          console.log(this.departList, ' this.departLis============================')
        }
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    change(v, l, s) {
      console.log(v, l, s)
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleOk() {
      this.$refs.table.refresh(true)
    },
    handFlow(row) {
      var obj = {
        procInstId: row.procInstId,
        procDefKey: row.processDefKey,
      }
      this.$refs.modal.show(obj)
    },
    handelAudit(record) {
       var fdStart =  record.processDefKey.indexOf("payment-");
      if(fdStart == 0) {
        console.log('111111111111111111111111')
         this.$refs.paymentmodal.show(record)
      } else {
        console.log(record,'22222222222222222222222222')
          const modal = modalMap[record.processDefKey]
          this.$refs[modal].show(record)

      }
       
     
    },
    handelAuditBatch(taskIds, result) {
      auditTaskBatch({
        taskIds: taskIds,
        result: result,
      }).then((res) => {
        if (res.code === 200) {
          this.handleOk()
        }
      })
    },
    // get_lis2() {
    // 	assetget_list2({
    // 		page_size: this.pagination2.pageSize,
    // 		page_num: this.pagination2.current,
    // 		name: this.scrapPara.name,
    // 		asset_sn: this.scrapPara.asset_sn,
    // 		discard: 1,
    // 	}).then((res) => {
    // 		const pagination2 = {
    // 			...this.pagination2
    // 		}
    // 		pagination2.total = res.data.total
    // 		this.pagination2 = pagination2
    // 		this.data2 = res.data.items
    // 		this.data2.forEach((item) => {
    // 			item.purchase_price = item.purchase_price / 100
    // 			item.value = item.value / 100
    // 		})
    // 	})
    // 		},
    // 		handleTableChange2(pagination, filters, sorter) {
    // 			this.pagination2.current = pagination.current
    // 			this.get_lis2()
    // 		},
    // 		scrapquery() {
    // 			this.pagination2.current = 1
    // 			this.get_lis2()
    // 		},
    // // handleTableChange2
    // 改变分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.loading = true
      this.get_lis2()
    },
  },
  watch: {
    /*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
  },
}
</script>
